import { Flex, Text } from "@chakra-ui/react";
import { IconDnaFusion, IconUpgrade } from "icons";
import { useRouter } from "next/router";

const FusionTag = () => {
  const router = useRouter();

  return (
    <Flex
      background="linear-gradient(225deg, rgba(109, 177, 241, 0.2) 0%, rgba(79, 138, 197, 0.2) 18%, rgba(38, 102, 166, 0.2) 73%, rgba(26, 59, 116, 0.2) 100%)"
      borderRadius="4px"
      position="relative"
      _before={{
        content: '""',
        position: "absolute",
        inset: 0,
        borderRadius: "4px",
        padding: "2px",
        background: 'linear-gradient(360deg, rgba(42, 102, 255, 0.6) 0%, rgba(42, 102, 255, 0.24) 100%)',
        mask: "linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)",
        maskComposite: "exclude",
      }}
      gap="2"
      shadow="0px 2px 6px 2px rgba(0, 0, 0, 0.15)"
      alignItems="center"
      px="8px"
      pr="12px"
      py="8px"
      zIndex="100"
      cursor="pointer"
      onClick={() => {
        router.push('/fusion');
      }}
    >
      <IconDnaFusion 
        __css={{
          path: {
            fill: "rgba(109, 177, 241, 1)"
          }
        }}
        boxSize={4}
      />

      <Text
        fontSize="12.5px"
        lineHeight="16px"
        fontWeight="400"
        fontFamily="heading"
        color="rgba(109, 177, 241, 1)"
      >
        FUSION
      </Text>
    </Flex>
  );
};

export default FusionTag;